"use strict";
/**
 * Feedback System API Types
 *
 * Types for user feedback and access requests.
 *
 * Derivation:
 * - FeedbackItem: derived from FeedbackRecord using Pick for the fields that
 *   getAccessRequests() and getFeedback() handlers explicitly map from DynamoDB items.
 *   The handlers manually construct response objects selecting specific fields,
 *   so Pick accurately represents the API surface.
 * - Enums and request types remain standalone (Requirement 9).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackStatus = exports.FeedbackType = exports.FeedbackModeration = exports.FeedbackMessageType = void 0;
// ===== ENUMS =====
var FeedbackMessageType;
(function (FeedbackMessageType) {
    FeedbackMessageType["REQUEST_ACCESS"] = "request_access";
    FeedbackMessageType["FEEDBACK"] = "feedback";
})(FeedbackMessageType || (exports.FeedbackMessageType = FeedbackMessageType = {}));
var FeedbackModeration;
(function (FeedbackModeration) {
    FeedbackModeration["ACCESS_REQUESTS"] = "access_requests";
    FeedbackModeration["GENERAL_FEEDBACK"] = "general_feedback";
})(FeedbackModeration || (exports.FeedbackModeration = FeedbackModeration = {}));
var FeedbackType;
(function (FeedbackType) {
    FeedbackType["INVITE_REQUEST"] = "invite_request";
    FeedbackType["GENERAL_FEEDBACK"] = "general_feedback";
    FeedbackType["BUG_REPORT"] = "bug_report";
    FeedbackType["FEATURE_REQUEST"] = "feature_request";
    FeedbackType["OTHER"] = "other";
})(FeedbackType || (exports.FeedbackType = FeedbackType = {}));
var FeedbackStatus;
(function (FeedbackStatus) {
    FeedbackStatus["PENDING"] = "pending";
    FeedbackStatus["RESOLVED"] = "resolved";
    FeedbackStatus["DISMISSED"] = "dismissed";
})(FeedbackStatus || (exports.FeedbackStatus = FeedbackStatus = {}));
